import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LegendBtnConfig } from '../../legend/LegendButtons';
import { ButtonType } from '../../legend/ButtonType';
import { NgClass } from '@angular/common';
import { AnatomicMapTooltipDirective } from '../anatomic-map-tooltip/anatomic-map-tooltip.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'legend-button',
    templateUrl: './legend-button.component.html',
    styleUrls: ['./legend-button.component.scss'],
    imports: [NgClass, AnatomicMapTooltipDirective, TranslatePipe],
    standalone: true,
})
export class LegendButtonComponent {
    @Input() buttonConfig: LegendBtnConfig;

    @Input() disabled: boolean;

    @Output() buttonClick: EventEmitter<LegendBtnConfig> = new EventEmitter<LegendBtnConfig>();

    onButtonClick() {
        if (!this.disabled) {
            this.buttonClick.emit(this.buttonConfig);
        }
    }

    getTranslationLabel(btnType: ButtonType): string {
        if (btnType === 'type1') {
            return 'XAll';
        }
        if (btnType === 'type2') {
            return 'XSelected';
        }
    }
}
